// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IFeeModificationDto
 */
export interface IFeeModificationDto {
    /**
     * 
     * @type {number}
     * @memberof IFeeModificationDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IFeeModificationDto
     */
    fee_flow_type?: IFeeModificationDtoFeeFlowTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IFeeModificationDto
     */
    claim_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IFeeModificationDto
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IFeeModificationDto
     */
    paid_fee_account_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IFeeModificationDto
     */
    paid_fee_plan_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IFeeModificationDto
     */
    returned_fee_amount_account_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IFeeModificationDto
     */
    returned_fee_amount_plan_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IFeeModificationDto
     */
    transaction_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof IFeeModificationDto
     */
    transaction_at?: Date;
    /**
     * 
     * @type {number}
     * @memberof IFeeModificationDto
     */
    next_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IFeeModificationDto
     */
    original_fee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IFeeModificationDto
     */
    partner_organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IFeeModificationDto
     */
    fee_type?: IFeeModificationDtoFeeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IFeeModificationDto
     */
    payment_fee_type?: IFeeModificationDtoPaymentFeeTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IFeeModificationDtoFeeFlowTypeEnum {
    REVERSAL = 'REVERSAL',
    TRANSFER = 'TRANSFER'
}
/**
* @export
* @enum {string}
*/
export enum IFeeModificationDtoFeeTypeEnum {
    PAYMENT_FEE = 'PAYMENT_FEE',
    ACCOUNT_MAINTENANCE_FEE = 'ACCOUNT_MAINTENANCE_FEE',
    PAPER_STATEMENT_FEE = 'PAPER_STATEMENT_FEE'
}
/**
* @export
* @enum {string}
*/
export enum IFeeModificationDtoPaymentFeeTypeEnum {
    ACH = 'ACH',
    DEBIT = 'DEBIT',
    VENMO = 'VENMO',
    PAYPAL = 'PAYPAL',
    CHECK = 'CHECK'
}


/**
 * Check if a given object implements the IFeeModificationDto interface.
 */
export function instanceOfIFeeModificationDto(value: object): value is IFeeModificationDto {
    return true;
}

export function IFeeModificationDtoFromJSON(json: any): IFeeModificationDto {
    return IFeeModificationDtoFromJSONTyped(json, false);
}

export function IFeeModificationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IFeeModificationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'fee_flow_type': json['fee_flow_type'] == null ? undefined : json['fee_flow_type'],
        'claim_id': json['claim_id'] == null ? undefined : json['claim_id'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'paid_fee_account_id': json['paid_fee_account_id'] == null ? undefined : json['paid_fee_account_id'],
        'paid_fee_plan_name': json['paid_fee_plan_name'] == null ? undefined : json['paid_fee_plan_name'],
        'returned_fee_amount_account_id': json['returned_fee_amount_account_id'] == null ? undefined : json['returned_fee_amount_account_id'],
        'returned_fee_amount_plan_name': json['returned_fee_amount_plan_name'] == null ? undefined : json['returned_fee_amount_plan_name'],
        'transaction_id': json['transaction_id'] == null ? undefined : json['transaction_id'],
        'transaction_at': json['transaction_at'] == null ? undefined : (new Date(json['transaction_at'])),
        'next_id': json['next_id'] == null ? undefined : json['next_id'],
        'original_fee_id': json['original_fee_id'] == null ? undefined : json['original_fee_id'],
        'partner_organization_id': json['partner_organization_id'] == null ? undefined : json['partner_organization_id'],
        'fee_type': json['fee_type'] == null ? undefined : json['fee_type'],
        'payment_fee_type': json['payment_fee_type'] == null ? undefined : json['payment_fee_type'],
    };
}

export function IFeeModificationDtoToJSON(json: any): IFeeModificationDto {
    return IFeeModificationDtoToJSONTyped(json, false);
}

export function IFeeModificationDtoToJSONTyped(value?: IFeeModificationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fee_flow_type': value['fee_flow_type'],
        'claim_id': value['claim_id'],
        'amount': value['amount'],
        'paid_fee_account_id': value['paid_fee_account_id'],
        'paid_fee_plan_name': value['paid_fee_plan_name'],
        'returned_fee_amount_account_id': value['returned_fee_amount_account_id'],
        'returned_fee_amount_plan_name': value['returned_fee_amount_plan_name'],
        'transaction_id': value['transaction_id'],
        'transaction_at': value['transaction_at'] == null ? undefined : ((value['transaction_at']).toISOString()),
        'next_id': value['next_id'],
        'original_fee_id': value['original_fee_id'],
        'partner_organization_id': value['partner_organization_id'],
        'fee_type': value['fee_type'],
        'payment_fee_type': value['payment_fee_type'],
    };
}

